import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { UniversityType } from "../../../types/University";
import { get, post, put } from "../../../utils/axios-config";
import { UNIVERSITIES, UNIVERSITIES_BY_IDS_UNIVERSITIES } from "../../../utils/constants";

export const createUniversity = async (data: UniversityType) => 
    await post<UniversityType, string>(UNIVERSITIES, data);

export const getUniversities = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    return await get<PagedResultsType<UniversityType>>(`${UNIVERSITIES}?${queryParams.toString()}`);
};
export const getUniversitiesByIdFaculties = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    const url = `${UNIVERSITIES_BY_IDS_UNIVERSITIES}?${queryParams.toString()}`;
    return await post<string[],PagedResultsType<UniversityType>>(url, data?.IdsFaculties!)
};

export const updateUniversity = async (data: UniversityType) => 
    await put<UniversityType, string>(UNIVERSITIES, data);
